import type { HoppModule } from "@hoppscotch/common/modules"

import { authEvents$, probableUser$ } from "@app/platform/auth/web"

/**
 * Redirects unauthenticated users to Microsoft SSO before the app renders.
 * Only active in web (non-desktop) mode.
 */
export const authRequiredModule: HoppModule = {
  onRouterInit(_app, router) {
    // Resolves once we know whether the user is authenticated or not.
    // We listen for the first definitive auth event from performAuthInit().
    const authDetermined = new Promise<"authenticated" | "unauthenticated">(
      (resolve) => {
        // Fast-path: probableUser already loaded from localStorage cache
        if (probableUser$.value) {
          resolve("authenticated")
          return
        }

        const sub = authEvents$.subscribe((event) => {
          if (event.event === "login" || event.event === "probable_login") {
            sub.unsubscribe()
            resolve("authenticated")
          } else if (event.event === "logout") {
            sub.unsubscribe()
            resolve("unauthenticated")
          }
        })

        // Fallback after 4 s — re-check stream in case events were missed
        setTimeout(() => {
          sub.unsubscribe()
          resolve(probableUser$.value ? "authenticated" : "unauthenticated")
        }, 4000)
      }
    )

    router.beforeEach(async () => {
      const state = await authDetermined

      if (state === "unauthenticated") {
        // Kick off Microsoft SSO; after login the backend redirects back to VITE_BASE_URL
        window.location.href = `${
          import.meta.env.VITE_BACKEND_API_URL
        }/auth/microsoft?redirect_uri=${encodeURIComponent(
          import.meta.env.VITE_BASE_URL
        )}`
        return false
      }
    })
  },
}
